import { readonly, ref } from 'vue'
import moment from 'moment'
import {
  WhatsappConversation,
  WhatsappGalidanciaService,
} from '@/services/WhatsappGalidanciaService'

const unreadCount = ref(0)
let intervalId: number | null = null
let subscribers = 0

const isSessionAlive = (conversation: WhatsappConversation) => {
  if (conversation.session_open === false) return false
  if (!conversation.session_expires_at) return true
  return moment(conversation.session_expires_at).isAfter()
}

const fetchUnreadCount = async () => {
  try {
    const response = await WhatsappGalidanciaService.listConversations({
      page: 1,
      per_page: 100,
    })
    const total = (response.data || [])
      .filter(isSessionAlive)
      .reduce((sum, conversation) => sum + (Number(conversation.unread_count) || 0), 0)
    unreadCount.value = total
  } catch {
    // El globo sigue visible; el número se actualiza en el siguiente sondeo.
  }
}

const start = () => {
  subscribers += 1
  if (intervalId !== null) return
  void fetchUnreadCount()
  intervalId = window.setInterval(() => {
    void fetchUnreadCount()
  }, 120000)
}

const stop = () => {
  subscribers = Math.max(0, subscribers - 1)
  if (subscribers > 0 || intervalId === null) return
  window.clearInterval(intervalId)
  intervalId = null
}

export function useWhatsappUnread() {
  return {
    unreadCount: readonly(unreadCount),
    fetchUnreadCount,
    start,
    stop,
  }
}
